import ImageViewer from '@vendors/ImageViewer/ImageViewer.js';

class ImageViewerAutoloader {

  constructor() {
    // console.log('al');
    // this.links = [...document.querySelectorAll(`[rel^="lightbox-"]`)];
    this.links = Array.prototype.slice.call(document.querySelectorAll(`[rel^="lightbox-"]`), 0);
    // console.log('al2');
    if (this.links.length > 0) {
      this.init();
    }
  }

  init() {
    this.viewer = new ImageViewer();

    this.links.forEach((link) => {

      link.addEventListener('click', (e) => {
        e.preventDefault();

        const group = this.getLinkGroup(link);
        let startIndex=0;
        
        // build the list of images that will be displayed      
        const groupLinks = this.links.filter((item) => {
                return (this.getLinkGroup(item) == group)
              })
              .map((item, index) => {
                if (item == link) startIndex = index;
                return this.linkMapper(item);
              })

        // console.log(link);
debugger;

        this.viewer.open(groupLinks, startIndex);
      })
    })
  }  

  // возвращает номер группы, к которой принадлежит ссылка
  getLinkGroup(link) {
    return link.getAttribute('rel').split('-')[1];
  }

  /**
   * На основании атрибутов ссылки возвращает данные для изображения, предназначенные для отображения в окне просмотра
   * @param {HTMLAnchorElement} link 
   * @returns {slideData}
   */
  linkMapper(link) {
    return {
      src: link.href,
      caption: link.title
    };
  }

}

export default ImageViewerAutoloader;